<template>
	<div class="ms-cell-editor">
		<div
			v-show="!isSelected || readOnly"
			class="flex-center"
			:class="{ 'edit-disabled': readOnly, 'ms-editor-text': editable }"
		>
			<div class="editor-display">
				<span>{{
					dataRow[col.dataField]
						| formatData({ formatType: col.formatType, enumName: col.enumName })
				}}</span>
			</div>

			<div
				class="icon-input float-right"
				v-tooltip="{
					content: cellErrorProvider.message,
					classes: 'error',
					placement: getPlacementTooltip(col),
				}"
				v-if="cellErrorProvider.isValid"
			>
				<div class="mi mi-20 mi-icon-error"></div>
			</div>
		</div>
		<div
			class="ms-editor w-full h-full"
			ref="editor"
			v-show="isSelected && !readOnly && editable"
		></div>
	</div>
</template>
<script>
import msInput from '@/components/msinput/msInput.vue';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import Vue from 'vue';
export default {
	name: 'msCellInput',
	extends: msBaseComponent,
	props: {
		col: {},
		dataRow: {},
		rowIndex: {
			default: 0,
			type: Number,
		},
		colIndex: {
			default: 0,
			type: Number,
		},
		//Thuộc tính để cấu hình cho phép sửa trên grid hay không
		editable: {
			default: true,
			type: Boolean,
		},
		rowSelected: {
			default: null,
		},
	},
	components: {
		msInput,
	},
	computed: {
		readOnly() {
			const me = this;
			if (!me.editable) {
				return true;
			}
			if (me.col && typeof me.col.readOnly == 'function') {
				return me.col.readOnly(me.dataRow);
			} else {
				return me.col.readOnly;
			}
		},
		// checkDataEmpty() {
		// 	const me = this;
		// 	return me.$ms.commonFunc.objectHasDataEmpty(me.dataRow, ['__vKeyValue']);
		// }
	},
	mounted() {
		const me = this;
		if (!me.dataRow.hasOwnProperty(me.col.dataField)) {
			me.$set(me.dataRow, me.col.dataField, undefined);
		}
		let watchName = 'dataRow.' + me.col.dataField;
		me.$watch(watchName, function (newVal, oldVal) {
			me.$nextTick(() => {
				me.validateCell();
			});
		});
	},
	data() {
		return {
			isSelected: false,
			cellErrorProvider: {},
		};
	},
	watch: {
		isSelected: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal == false) {
					if (me.col.__editor) {
						if (me.col.__editor.errorProvider) {
							me.col.__editor.errorProvider = {};
						}
					}
					me.$nextTick(() => {
						me.validateCell();
					});
				} else {
					if (me.$el) {
						let content = me.$el.closest('.ms-content--table');
						if (content) {
							if (
								me.$el.getBoundingClientRect().right >=
								content.getBoundingClientRect().right
							) {
								content.scrollLeft += me.$el.getBoundingClientRect().x - 20;
							}
						}
					}
				}
			},
		},
		'col.rules': {
			handler(newVal, oldVal) {
				const me = this;
				if (!newVal) {
					me.$nextTick(() => {
						me.validateCell();
					});
				}
			},
		},
	},
	methods: {
		//Hàm validate trên từng cell
		validateCell() {
			const me = this;
			// if (me.checkDataEmpty) {
			// 	return;
			// }
			if (!me.readOnly) {
				let col = me.col,
					rulesValidate = null,
					ret = false;
				let rules = col.rules;
				if (col.rules && typeof col.rules == 'function') {
					rules = col.rules(me.dataRow);
				}
				if (rules) {
					let listRules = rules.split('|');
					for (let i = 0; i < listRules.length; i++) {
						let data = me.dataRow[me.initField] || me.dataRow[col.dataField];
						let dataSource = me.dataRow[me.col.getDataFromField];
						ret = !me.validateRule(
							listRules[i],
							data,
							col.__editor,
							dataSource
						);
						if (ret) {
							rulesValidate = listRules[i];
							break;
						}
					}
					if (ret) {
						if (me.$t('i18nValidate').messages[rulesValidate]) {
							me.$set(
								me.cellErrorProvider,
								'message',
								me.$t('i18nValidate').messages[rulesValidate](col.title)
							);
						}
						me.$set(me.cellErrorProvider, 'isValid', true);
						me.$set(me.cellErrorProvider, 'rules', rulesValidate);
						me.$set(me.cellErrorProvider, 'element', me);
					} else {
						me.cellErrorProvider = {};
					}
				} else {
					me.cellErrorProvider = {};
				}
			}
		},
		//Khởi tạo editor
		//Created by LTDAT(17.06.2020)
		createdEditor() {
			const me = this;

			let editorControl = me.getEditorControl(),
				col = me.col,
				editorExtend = Vue.extend(editorControl),
				editorProperty = me.getEditorProperty(),
				instance = new editorExtend(editorProperty);
			instance.vm = instance.$mount();
			instance.$cell = me;
			col.__editor = instance;
			me.addHandler(instance);
			return instance;
		},
		//Điều hướng đến đúng cell cần edit
		directEventInput() {
			let me = this,
				col = me.col,
				editor = me.col.__editor;
			if (editor) {
				if (editor.validate) {
					editor.validate();
				}
				editor.$cell.inputHandler(...arguments);
			}
		},
		//Điều hướng đến đúng cell cần edit
		directEventChange() {
			let me = this,
				col = me.col,
				editor = me.col.__editor;
			if (editor) {
				editor.$cell.changeHandler(...arguments);
			}
		},
		//Điều hướng cho sự kiện change
		changeHandler(value) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: value,
				oldValue: me.dataRow[me.col.dataField],
				cell: me,
			};

			me.$emit('change', metaData);
		},
		//Hàm xử lý sự kiện editor input
		inputHandler(value) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			me.$set(dataRow, col.dataField, value);
			// dataRow[col.dataField] = value;
		},
		//Xử lý sự kiện từ editor raise ra ngoài
		addHandler(editor) {
			const me = this;
			editor.$on('input', me.directEventInput);
			editor.$on('change', me.directEventChange);
			me.addCustomHandler(editor);
		},
		//Các loại control khác có event có thể Overide hàm này
		//Created by LTDAT(18.06.2020)
		addCustomHandler(editor) {},
		//Lấy loại control
		//Created by LTDAT(17.06.2020)
		getEditorControl() {
			return msInput;
		},
		//Lấy thuộc tính truyền vào trong editor
		//Created by LTDAT(17.06.2020)
		getEditorProperty() {
			const me = this;
			let col = me.col;
			if (me.customEditProperty && typeof me.customEditProperty == 'function') {
				me.customEditProperty(col.editorProperty);
			}
			return col.editorProperty;
		},
		//Sự kiện click vào cell editor
		cellSelected() {
			const me = this;
			let col = me.col,
				editor = col.__editor;
			me.isSelected = true;
			if (!editor && me.$refs.editor) {
				editor = me.createdEditor();
			}
			if (editor) {
				editor.$cell = me;
				me.$nextTick(() => {
					me.beforeEdit(editor);
					me.$refs.editor.appendChild(editor.$el);
					me.focusEditor(editor);
				});
			}
		},
		//Focus vào editor
		focusEditor(editor) {
			const me = this;
			let input = this.$refs.editor.querySelector('input,textarea');
			setTimeout(() => {
				if (input) {
					input.focus();
					input.select();
				}
			}, 100);
		},
		//Hàm xử lý trước khi edit reset lại các giá trị trong editor cũ
		//Created by LTDAT(17.06.2020)
		beforeEdit(editor) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			if (editor) {
				me.customBeforeEdit();
				if (typeof editor.reset === 'function') {
					editor.reset();
				}
				if (typeof editor.setValue === 'function') {
					editor.setValue(dataRow[col.dataField]);
				}
				if (editor.applyValidate && typeof editor.applyValidate == 'function') {
					me.$nextTick(() => {
						editor.applyValidate(me.cellErrorProvider.message);
					});
				}
			}
			me.$emit('rowSelected', me.dataRow);
		},
		customBeforeEdit() {},
		getPlacementTooltip(col) {
			const me = this;
			//Mặc định là bottom
			if (
				!col ||
				!col.editorProperty ||
				!col.editorProperty.propsData ||
				!col.editorProperty.propsData.placementTooltip
			) {
				return 'bottom';
			}

			return col.editorProperty.propsData.placementTooltip;
		},
	},
};
</script>
<style lang="scss" scoped>
.editor-display {
	padding: 6px 8px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
.mi-icon-error {
	margin-right: 8px;
}
</style>
